export default __webpack_public_path__ + "media/images/bag-f4b83fa96969bf7de905832824600f55.svg";